namespace RioERP.Masters {
    export interface BrandAmbassadorSettingsForm {
        CouponCodePrefix: Serenity.StringEditor;
        RunProgram: Serenity.BooleanEditor;
        SendEmails: Serenity.BooleanEditor;
        OnOrOff: Serenity.BooleanEditor;
        SiteUrl: Serenity.StringEditor;
        NopEmail: Serenity.StringEditor;
        NopUserName: Serenity.StringEditor;
        NopPassword: Serenity.StringEditor;
        CreateNopTokenUrl: Serenity.StringEditor;
        DiscountCreateNopUrl: Serenity.StringEditor;
        DiscountCategoryMappingNopUrl: Serenity.StringEditor;
        DiscountPercentage: Serenity.DecimalEditor;
        BrandAmbassadorSharePercentage: Serenity.DecimalEditor;
        DiscountCategoryId: Serenity.IntegerEditor;
        CreateGiftCard: Serenity.BooleanEditor;
        CreateGiftCardUrl: Serenity.StringEditor;
    }

    export class BrandAmbassadorSettingsForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.BrandAmbassadorSettings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BrandAmbassadorSettingsForm.init)  {
                BrandAmbassadorSettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;

                Q.initFormType(BrandAmbassadorSettingsForm, [
                    'CouponCodePrefix', w0,
                    'RunProgram', w1,
                    'SendEmails', w1,
                    'OnOrOff', w1,
                    'SiteUrl', w0,
                    'NopEmail', w0,
                    'NopUserName', w0,
                    'NopPassword', w0,
                    'CreateNopTokenUrl', w0,
                    'DiscountCreateNopUrl', w0,
                    'DiscountCategoryMappingNopUrl', w0,
                    'DiscountPercentage', w2,
                    'BrandAmbassadorSharePercentage', w2,
                    'DiscountCategoryId', w3,
                    'CreateGiftCard', w1,
                    'CreateGiftCardUrl', w0
                ]);
            }
        }
    }
}
